export const AVATAR_DATA = [
    {
      url: "https://cdn3.iconfinder.com/data/icons/avatars-9/145/Avatar_Dog-512.png",
      title: "Dog",
    },
    {
      url: "https://cdn3.iconfinder.com/data/icons/avatars-9/145/Avatar_Cat-512.png",
      title: "Cat",
    },
    {
      url: "https://cdn3.iconfinder.com/data/icons/avatars-9/145/Avatar_Panda-512.png",
      title: "Panda",
    },
    {
      url: "https://cdn3.iconfinder.com/data/icons/avatars-9/145/Avatar_Penguin-512.png",
      title: "Penguin",
    },
    {
      url: "https://static.vecteezy.com/system/resources/thumbnails/020/647/520/small_2x/pig-face-icon-cute-animal-icon-in-circle-png.png",
      title: "Pig",
    },
  ];
  